/**
 * dog-edit.js
 */

import React from 'react';
import axios from 'axios';
import { useHistory, useRouteMatch, matchPath } from "react-router-dom";
import { parseISO } from 'date-fns';
import MenuDrawer from "components/menu-drawer";
import DogMenu from './dog-menu';
import DogDetails from './dog-details';
import DogPhoto from './dog-photo';
import DogVaccinations from './dog-vaccinations';
import DogDocuments from './dog-documents';


export default function DogEdit(props) {
  const { dog: propsDog } = props;
  const history = useHistory();
  const { path: basePath, url } = useRouteMatch();
  const drawerPath = '/:dogId?/:action(add|edit)';
  const drawerBasePath = basePath + drawerPath;
  const [dog, setDog] = React.useState(propsDog);

  const menuRoutes = [
    {
      component: DogMenu,
      path: [drawerBasePath]
    }
  ];

  const desktopRoutes = [
    {
      component: DogDetails,
      path: [ `${drawerBasePath}/details`],
      exact: true
    },
    {
      component: DogPhoto,
      path: [ `${drawerBasePath}/photo` ],
      exact: true
    },
    {
      component: DogVaccinations,
      path: [`${drawerBasePath}/vaccinations`],
      exact: true
    },
    {
      component: DogDocuments,
      path: [ `${drawerBasePath}/docs` ],
      exact: true
    }
  ];

  const mobileRoutes = [...desktopRoutes];

  // check if we need to query the dog manually
  React.useEffect(() => {
    if (!dog) {
      const match = matchPath(history.location.pathname, drawerBasePath);
      if (match && match.params.dogId) {
        (async () => {
          const response = await axios.get(`/dogs/${match.params.dogId}`);
          if (response.status === 200) {
            const newDog = response.data;
            if (newDog && newDog.id) {
              setDog({
                ...newDog,
                dateBirth: newDog.dateBirth ? parseISO(newDog.dateBirth) : null,
                dateStarted: newDog.dateStarted ? parseISO(newDog.dateStarted) : null,
                dateRetired: newDog.dateRetired ? parseISO(newDog.dateRetired) : null
              });
            }
          }
        })();
      }
    }
  }, [history, drawerBasePath, dog]);

  // update when dog prop changes
  React.useEffect(() => {
    if (propsDog) {
      setDog(propsDog);
    }
  }, [propsDog]);

  const onCloseDrawer = () => {
    if (props.onClose) {
      props.onClose();
    }
    history.push(url);
  } 

  return (
    <>
      <MenuDrawer
        {...props}
        dog={dog}
        drawerPath={drawerPath}
        basePath={basePath}
        menuRoutes={menuRoutes}
        desktopRoutes={desktopRoutes}
        mobileRoutes={mobileRoutes} 
        title={`${dog && dog.id ? 'EDIT' : 'ADD'} DOG`}
        subtitle={dog 
          ? `${dog.id 
            ? `${dog.name.toLowerCase().includes('k9') 
              ? dog.name 
              : `K9 ${dog.name}`}` 
            : ''}` 
          : '' }
        onClose={onCloseDrawer}
        />
    </>
  );

};